import { useRef, useMemo } from "react";
import { Box, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import DeleteIcon from "@mui/icons-material/Delete";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import AgGridLoader from "../AgGridLoader";
import { getHeaderClass } from "../../utils/agGridHelpers";

const UserTable = ({
  users,
  currentUserId,
  onEdit,
  onDelete,
  onViewHistory,
}) => {
  const gridRef = useRef(null);

  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Actions",
        field: "actions",
        flex: 1,
        cellRenderer: (params) => (
          <Box>
            <IconButton
              onClick={() => onEdit(params.data)}
              sx={{ color: "#1976d2" }}
              aria-label="Edit"
              data-log="Edit Icon Button"
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={() => onDelete(params.data)}
              sx={{ color: "#d32f2f" }}
              aria-label="Delete"
              data-log="Delete Icon Button"
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              onClick={() => onViewHistory(params.data)}
              title="View Update History"
              style={{ color: "#1976D2" }}
              aria-label="View Update History"
              data-log="View History Icon Button"
            >
              <HistoryIcon />
            </IconButton>
          </Box>
        ),
      },
      {
        headerName: "Username",
        field: "username",
        flex: 1,
        cellRenderer: (params) => (
          <Box display="flex" alignItems="center">
            {params.data._id === currentUserId && (
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  bgcolor: "green",
                  borderRadius: "50%",
                  mr: 1,
                }}
              />
            )}
            {params.value}
          </Box>
        ),
      },
      { headerName: "Email", field: "email", flex: 1 },
      { headerName: "Role", field: "role", flex: 1 },
    ],
    [onEdit, onDelete, onViewHistory, currentUserId]
  );

  return (
           <div style={{ width: "100%", display: "flex", flexDirection: "column", height: "calc(100vh - 200px)" }}>
    <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" , overflow: "auto" }}>
      <AgGridReact
        ref={gridRef}
        rowData={users ?? []}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        pagination
        paginationPageSize={10}
        paginationPageSizeSelector={[10, 20, 50, 100]}
        onGridReady={onGridReady}
        defaultColDef={{ headerClass: getHeaderClass }}
        loadingOverlayComponent={AgGridLoader}
        loadingOverlayComponentParams={{ loadingMessage: "Loading users, please wait..." }}
      />
    </div>
    </div>
  );
};

export default UserTable;
